/*
  SunBorn 9/30 — Free US shipping messaging (geo-aware).
  US shoppers: cart/minicart progress bar becomes a static line —
  fast truck (angled forward, 3 speed lines) + green pulse dot + green check + bold
  "Free US shipping on this order". Tax note reads "Free US shipping · Taxes calculated
  at checkout". PDP trust row reads "Free US Shipping".
  Everyone else: free-shipping bar kept, copy says "international".
  Minicart trust block (payment icons + trust grid): moved BELOW the Checkout button
  (into .sb-sticky-checkout-zone) and given a 3rd cell — "Free Tracked US Shipping"
  (US) / "Free Shipping Over <threshold>" (international). The checkout button's bottom
  bleed (margin-bottom:-25px) is cancelled once the block sits under it.
  Country comes from Shopify.country (the shopper's market). Loaded sitewide from
  snippets/back-to-top.liquid. Re-applies on cart drawer / cart page re-renders.
  SunBorn 10/4: "Lost-Package Coverage" icon was blank — the subset feather font
  (assets/sunborn-icons.css) has no package glyph; .feather-package now maps to the
  feather "box" glyph (\e925). Drawer bottom padding under the trust row cut from
  30px to the minimum (4px, or the iPhone home-bar safe area when larger).

  SunBorn 10/12: international free-shipping minimum raised $80 -> $150 USD (matches
  the shipping rates in Settings > Shipping). The theme's own bar compares the USD
  setting against a cart total in the shopper's currency, so for non-US shoppers the
  bar is now recomputed here from /cart.js and Shopify.currency.rate, and the amount
  is shown in the shopper's currency (e.g. "Free Shipping Over £114").
  UK & Europe market (GB, EU members we sell to, NO, CH): prices carry +20% to cover
  the VAT our fulfillment partner charges. Those shoppers see "Price includes VAT ·
  No fees on delivery" under the PDP price, and the cart tax note says VAT is included.
  Australia & NZ market: prices carry +10% for the GST our fulfillment partner charges;
  same notes, worded for GST.
*/
(function () {
  var INTL_FREE_SHIP_USD = 150;
  var VAT_COUNTRIES = ['GB', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FI', 'FR', 'IE', 'IT', 'NL', 'PL', 'PT', 'SE', 'NO', 'CH'];

  var country = (window.Shopify && window.Shopify.country) ? String(window.Shopify.country).toUpperCase() : 'US';
  var isUS = country === 'US';
  var GST_COUNTRIES = ['AU', 'NZ'];
  var isVat = VAT_COUNTRIES.indexOf(country) !== -1;
  var isGst = GST_COUNTRIES.indexOf(country) !== -1;
  var TAX_WORD = isGst ? 'GST' : 'VAT';

  var cur = (window.Shopify && window.Shopify.currency) || {};
  var curCode = cur.active || 'USD';
  var rate = parseFloat(cur.rate) || 1;
  var thresholdLocal = Math.ceil(INTL_FREE_SHIP_USD * rate); // whole units, shopper currency

  function fmt(amount) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: curCode, maximumFractionDigits: amount % 1 === 0 ? 0 : 2, minimumFractionDigits: amount % 1 === 0 ? 0 : 2 }).format(amount);
    } catch (e) {
      return curCode + ' ' + amount;
    }
  }

  var US_TAX = 'Free US shipping · Taxes calculated at checkout';
  var VAT_TAX = TAX_WORD + ' included · No fees on delivery · Shipping calculated at checkout';
  var VAT_PDP = 'Price includes ' + TAX_WORD + ' · No fees on delivery';
  var INTL_SHIP_LABEL = 'Free Shipping Over ' + fmt(thresholdLocal);
  var TRUST_SHIP = isUS ? 'Free Tracked US Shipping' : INTL_SHIP_LABEL;
  var US_HTML =
    '<p class="mr-0 shipping-text shipping-bar-success sb-fs-us">' +
      '<span class="sb-fs-truck" aria-hidden="true">' +
        '<span class="sb-fs-lines"><i></i><i></i><i></i></span>' +
        '<i class="feather-truck"></i>' +
      '</span>' +
      '<span class="sb-fs-dot" aria-hidden="true"></span>' +
      '<span class="sb-fs-check" aria-hidden="true"><svg viewBox="0 0 16 16" width="14" height="14"><path d="M3 8.5l3.2 3.2L13 4.8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '<strong>Free US shipping on this order</strong>' +
    '</p>';

  var CSS =
    '.shipping-bar.sb-us-free .ship-probar{display:none!important}' +
    '.sb-fs-us{display:flex;align-items:center;gap:8px;flex-wrap:nowrap}' +
    '.sb-fs-us strong{font-weight:700;color:#111}' +
    '.sb-fs-truck{position:relative;display:inline-flex;align-items:center;padding-left:14px;color:#111}' +
    '.sb-fs-truck .feather-truck{font-size:17px;line-height:1;display:inline-block;transform:skewX(-14deg) rotate(-6deg);transform-origin:center}' +
    '.sb-fs-lines{position:absolute;left:0;top:50%;transform:translateY(-50%);display:flex;flex-direction:column;align-items:flex-end;gap:2px}' +
    '.sb-fs-lines i{display:block;height:2px;border-radius:2px;background:#111;animation:sbFsLine .9s ease-in-out infinite}' +
    '.sb-fs-lines i:nth-child(1){width:8px;animation-delay:0s}' +
    '.sb-fs-lines i:nth-child(2){width:12px;animation-delay:.15s}' +
    '.sb-fs-lines i:nth-child(3){width:6px;animation-delay:.3s}' +
    '@keyframes sbFsLine{0%,100%{opacity:.35;transform:translateX(0)}50%{opacity:1;transform:translateX(-3px)}}' +
    '.sb-fs-dot{position:relative;width:8px;height:8px;border-radius:50%;background:#16a34a;flex:0 0 8px}' +
    '.sb-fs-dot::after{content:"";position:absolute;inset:0;border-radius:50%;background:#16a34a;animation:sbFsPulse 1.6s ease-out infinite}' +
    '@keyframes sbFsPulse{0%{transform:scale(1);opacity:.7}100%{transform:scale(2.6);opacity:0}}' +
    '.sb-fs-check{display:inline-flex;color:#16a34a}' +
    '.sb-sticky-checkout-zone.sb-trust-below .sb-cart-checkout-btn{margin-bottom:0!important}' +
    '.sb-sticky-checkout-zone .sb-cart-footer-trust{margin:14px 0 0!important;padding-top:0!important;border-top:0!important}' +
    '.sb-sticky-checkout-zone .sb-trust-label{white-space:normal!important;overflow:visible!important;text-overflow:clip!important}' +
    '.feather-package:before{content:"\\e925"}' +
    '.mini-cart .sb-sticky-checkout-zone.sb-trust-below{padding-bottom:max(4px,env(safe-area-inset-bottom))!important}' +
    '.sb-vat-note{margin:6px 0 0;font-size:12px;line-height:1.4;color:#4a4638;letter-spacing:.01em}' +
    '@media (prefers-reduced-motion:reduce){.sb-fs-lines i,.sb-fs-dot::after{animation:none}}';

  function injectCSS() {
    if (document.getElementById('sb-fs-css')) return;
    var s = document.createElement('style');
    s.id = 'sb-fs-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function setText(el, txt) {
    if (el && el.textContent.trim() !== txt) el.textContent = txt;
  }

  function fixTrustBlock() {
    document.querySelectorAll('ajax-cart .sb-cart-footer-trust').forEach(function (tr) {
      var cart = tr.closest('ajax-cart');
      var zone = cart && cart.querySelector('.sb-sticky-checkout-zone');
      if (zone) {
        if (tr.parentNode !== zone) zone.appendChild(tr);
        if (!zone.classList.contains('sb-trust-below')) zone.classList.add('sb-trust-below');
      }
      var grid = tr.querySelector('.sb-trust-grid');
      if (!grid) return;
      var cell = grid.querySelector('.sb-trust-ship');
      if (!cell) {
        cell = document.createElement('div');
        cell.className = 'sb-trust-cell sb-trust-ship';
        cell.innerHTML = '<i class="feather-truck" aria-hidden="true"></i><span class="sb-trust-label"></span>';
        grid.appendChild(cell);
      }
      setText(cell.querySelector('.sb-trust-label'), TRUST_SHIP);
    });
  }

  /* Non-US bar: recompute from the real cart total in the shopper's currency. */
  var cartTotal = null; // minor units, shopper currency
  var fetching = false;
  var lastFetch = 0;
  var pendingTimer = null;
  function refreshCartTotal() {
    if (fetching || !window.fetch) return;
    var wait = 1200 - (Date.now() - lastFetch);
    if (wait > 0) {
      if (!pendingTimer) pendingTimer = setTimeout(function () { pendingTimer = null; refreshCartTotal(); }, wait);
      return;
    }
    lastFetch = Date.now();
    fetching = true;
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        fetching = false;
        if (c && typeof c.total_price === 'number' && c.total_price !== cartTotal) {
          cartTotal = c.total_price;
          schedule();
        }
      })
      .catch(function () { fetching = false; });
  }

  function paintIntlBar(bar) {
    if (cartTotal === null) return;
    var thresholdMinor = thresholdLocal * 100;
    var left = thresholdMinor - cartTotal;
    var pct = Math.max(0, Math.min(100, Math.round((cartTotal / thresholdMinor) * 100)));
    var txt = left <= 0
      ? 'You’ve unlocked free international shipping'
      : 'Spend ' + fmt(Math.ceil(left) / 100) + ' more for free international shipping';
    var t = bar.querySelector('.shipping-text');
    if (t) {
      setText(t, txt);
      t.classList.toggle('shipping-bar-success', left <= 0);
    }
    var want = pct + '%';
    if (bar.style.getPropertyValue('--shipping_procent') !== want) bar.style.setProperty('--shipping_procent', want);
    if (document.documentElement.style.getPropertyValue('--shipping_procent') !== want) document.documentElement.style.setProperty('--shipping_procent', want);
  }

  function addVatNotes() {
    if (!isVat && !isGst) return;
    document.querySelectorAll('.sb-pdp-price-block').forEach(function (block) {
      if (block.querySelector('.sb-vat-note')) return;
      var p = document.createElement('p');
      p.className = 'sb-vat-note';
      p.textContent = VAT_PDP;
      var save = block.querySelector('.sb-save-row');
      if (save && save.parentNode === block) block.insertBefore(p, save.nextSibling);
      else block.appendChild(p);
    });
    document.querySelectorAll('.tax-note').forEach(function (el) {
      if (el.textContent.trim() !== VAT_TAX) el.textContent = VAT_TAX;
    });
  }

  function apply() {
    var sawIntlBar = false;
    document.querySelectorAll('.shipping-bar').forEach(function (bar) {
      if (isUS) {
        bar.classList.add('sb-us-free');
        if (!bar.querySelector('.sb-fs-us')) bar.innerHTML = US_HTML;
      } else {
        // A freshly (re)rendered bar means the cart may have changed: refetch once.
        if (!bar.dataset.sbSeen) { bar.dataset.sbSeen = '1'; sawIntlBar = true; }
        bar.dataset.promote = 'Spend [value] more for free international shipping';
        bar.dataset.unlocked = 'You’ve unlocked free international shipping';
        paintIntlBar(bar);
      }
    });
    if (sawIntlBar) refreshCartTotal();

    if (isUS) {
      document.querySelectorAll('.tax-note').forEach(function (el) {
        if (/shipping/i.test(el.textContent) && el.textContent.trim() !== US_TAX) el.textContent = US_TAX;
      });
    }

    document.querySelectorAll('.sunborn-trust-text').forEach(function (el) {
      if (/free shipping/i.test(el.textContent) && !el.querySelector('a')) {
        setText(el, isUS ? 'Free US Shipping' : INTL_SHIP_LABEL);
      }
    });

    addVatNotes();
    fixTrustBlock();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }

  function init() {
    injectCSS();
    apply();
    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('cart:updated', function () { cartTotal = null; refreshCartTotal(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
